import { render, staticRenderFns } from "./OsusumeDetail.vue?vue&type=template&id=25ef9fba&scoped=true&"
import script from "./OsusumeDetail.vue?vue&type=script&lang=ts&"
export * from "./OsusumeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OsusumeDetail.vue?vue&type=style&index=0&id=25ef9fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ef9fba",
  null
  
)

component.options.__file = "OsusumeDetail.vue"
export default component.exports